import React, { useState } from 'react';
import Logo from '../../assets/images/2026.webp';
import PersonIcon from '../../assets/images/person.svg';
import ProfileIcon from '../../assets/images/profile.svg';
import LogoutIcon from '../../assets/images/logout.svg';
import DocumentImg from '../../assets/images/documents.svg';
import './Home.css';
function Home() {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const profilx = JSON.parse(localStorage.getItem('user'));
  const handleLogout = async () => {
    try {
      localStorage.clear();
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };
  return (
    <div className="homepage">
      <div className="header">
        <div className="logo-container">
          <img
            style={{ height: '185px' }}
            src={Logo}
            alt="Filadelfia Blessing Family"
          />
        </div>
        <div className="user-menu">
          <div
            className="user-icon"
            onClick={() => setDropdownVisible(!isDropdownVisible)}
          >
            <img src={PersonIcon} alt="Person Icon" />
          </div>
          {isDropdownVisible && (
            <div className="dropdown-menu">
              <a href="/profil">
                <div className="dropdown-item">
                  <span>Profil Anda</span> <img src={ProfileIcon} alt="" />
                </div>
              </a>
              <div className="dropdown-item" onClick={handleLogout}>
                <span>Logout</span> <img src={LogoutIcon} alt="" />
              </div>
            </div>
          )}
        </div>
      </div>
      <h3 style={{textAlign:'center',marginTop:'20px',fontSize:'20px'}}>Halo, {profilx.nama}.<br/>Selamat Datang di Filadelfia Blessing Family.</h3>
      <div className="button-grid">
        {profilx?.id_status === '2' && (
          <a href="/document">
            <div className="button documents">
              <img src={DocumentImg} alt="" />
              <span>RUKUN</span>
            </div>
          </a>
        )}
       
      </div>
    </div>
  );
}

export default Home;
